<!-- Shared edit / link coverage dialog. Coverage is derived from the selected
     requirement's node(s) in the zone (no free service dropdown; no file picker
     or preview). -->
<div class="documents-dialog">
  <div
    class="documents-dialog__background"
    data-testid="zone-doc-edit-backdrop"
    (click)="onCancel()"
  ></div>
  <div class="documents-dialog__content zone-upload-dialog zone-edit-dialog">
    <button
      type="button"
      class="documents-dialog__content__close"
      data-testid="zone-doc-edit-close"
      (click)="onCancel()"
    >
      <span class="material-icons">close</span>Close
    </button>
    <h2 class="zone-upload-dialog__title">Edit Document Coverage</h2>

    <div class="zone-edit-dialog__doc" *ngIf="document">
      <span class="material-icons">description</span>
      <span class="zone-edit-dialog__doc-name" [title]="document.fileName">
        {{ document.fileName }}
      </span>
    </div>

    <!-- "Applies to requirement" selector — the single link control. Choosing a
         requirement sets the document's licenseRequirementId and DERIVES its
         coverage from that requirement's node(s) in the zone, moving a
         pre-existing/legacy document under that named license's row. Rendered
         only when the zone offers requirements. -->
    <div
      class="zone-edit-dialog__requirement"
      *ngIf="selectableLicenses.length > 0"
    >
      <label class="cov-form__label" for="zone-edit-requirement">
        Applies to requirement
      </label>
      <select
        id="zone-edit-requirement"
        class="cov-form__service-select"
        data-testid="zone-doc-edit-requirement"
        [(ngModel)]="selectedLicenseRequirementId"
        (ngModelChange)="onLicenseSelect()"
      >
        <option [ngValue]="null">Not tied to a requirement</option>
        <option
          *ngFor="let license of selectableLicenses"
          [ngValue]="license.id"
        >
          {{ license.documentTitle }}
        </option>
      </select>
    </div>

    <!-- No requirements offered in this zone: no dead-end — dates only, saves as
         an Additional document. -->
    <p class="zone-edit-dialog__empty" *ngIf="selectableLicenses.length === 0">
      No license requirements apply to this zone.
    </p>

    <!-- Derived coverage. The chosen requirement drives the coverage form with the
         SAME presentation as the upload dialog: a read-only service chip plus a
         checkbox per configured sub-service of the requirement under that service,
         each pre-checked from the document's current coverage. Only when the
         requirement's nodes span more than one service does the user first pick
         which service the document covers (a document has ONE serviceType). -->
    <div class="zone-edit-dialog__coverage" *ngIf="coverageServices.length > 1">
      <label class="cov-form__label" for="zone-edit-service">
        Applies to service
      </label>
      <select
        id="zone-edit-service"
        class="cov-form__service-select"
        data-testid="zone-doc-edit-service"
        [(ngModel)]="selectedService"
        (ngModelChange)="onServiceSelect()"
      >
        <option [ngValue]="null" disabled>Select what this covers</option>
        <option *ngFor="let service of coverageServices" [ngValue]="service">
          {{ service.displayName }}
        </option>
      </select>
    </div>

    <div class="zone-upload-dialog__form zone-edit-dialog__form">
      <zone-doc-coverage-form
        [showServiceContext]="!!coverageService"
        [service]="coverageService"
        [scopedSubType]="null"
        [siblingSubTypes]="coverageSiblings"
        [initialExpiration]="initialExpiration"
        [initialIssueDate]="initialIssueDate"
        [expirationDateRequired]="expirationRequired"
        [issueDateRequired]="issueRequired"
        [licenseRequirementId]="selectedLicenseRequirementId"
        (coverageChange)="onCoverageChange($event)"
      ></zone-doc-coverage-form>
    </div>

    <!-- Footer: zone context + Cancel / Save -->
    <div class="documents-dialog__content__footer zone-upload-dialog__footer">
      <div class="documents-dialog__content__footer__service-type">
        <p class="documents-dialog__content__footer__service-type__label">
          Zone
        </p>
        <p class="documents-dialog__content__footer__service-type__text">
          {{ zoneLabel }}
        </p>
      </div>
      <div class="zone-upload-dialog__footer-actions">
        <button
          type="button"
          class="doc-btn zone-upload-dialog__cancel"
          data-testid="zone-doc-edit-cancel"
          (click)="onCancel()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="doc-btn doc-btn--primary"
          data-testid="zone-doc-edit-save"
          [disabled]="!canSave"
          (click)="onSave()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
